import PropTypes from 'prop-types';

import Modal from 'shopper/components/Modal';

import Heading from './Heading';
import Form from './StepperForm';

const LoginModal = ({
  gaEventCategory,
  greetingsMessage,
  onClose,
  onSuccess,
}) => (
  <Modal.Root size="size2">
    <Heading />
    <Modal.Body>
      <Form
        gaEventCategory={gaEventCategory}
        greetingsMessage={greetingsMessage}
        onClose={onClose}
        onSuccess={onSuccess}
      />
    </Modal.Body>
  </Modal.Root>
);

LoginModal.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  greetingsMessage: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
};

export default LoginModal;
